import { useState, useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import { isEmpty } from "lodash";
import "./CountDown.css";

const CountDown = ({ time, onTimeUp, className = "" }) => {
  const [targetTime, setTargetTime] = useState(Date.now() + time);
  const [timeLeft, setTimeLeft] = useState({});

  const calculateTimeLeft = useCallback(() => {
    const now = Date.now();
    const difference = targetTime - now;

    if (difference <= 0) return {};

    return {
      days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((difference / 1000 / 60) % 60),
      seconds: Math.floor((difference / 1000) % 60),
    };
  }, [targetTime]);

  useEffect(() => {
    const interval = setInterval(() => {
      const updatedTimeLeft = calculateTimeLeft();
      setTimeLeft(updatedTimeLeft);

      if (isEmpty(updatedTimeLeft)) {
        clearInterval(interval);
        onTimeUp?.();
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [calculateTimeLeft, onTimeUp]);

  useEffect(() => {
    setTargetTime(Date.now() + time);
  }, [time]);

  const { minutes = 0, seconds = 0 } = timeLeft;

  return (
    <div className={`helbest-countdown ${className}`}>
      {!isEmpty(timeLeft) && (
        <>
          {String(minutes).padStart(2, "0")} :{" "}
          {String(seconds).padStart(2, "0")}
        </>
      )}
    </div>
  );
};

CountDown.propTypes = {
  time: PropTypes.number.isRequired,
  onTimeUp: PropTypes.func,
  className: PropTypes.string,
};

export default CountDown;
